
































import { Component, Vue } from 'vue-property-decorator';
import { IColorDetail, IColorReadyData } from '@/components/color-wheel/types';
import ColorWheelPie from '@/components/color-wheel/ColorPie.vue';
import ColorWheelGray from '@/components/color-wheel/ColorGray.vue';
import ColorWheelSub from '@/components/color-wheel/ColorSub.vue';
import ColorWheelRelation from '@/components/color-wheel/ColorRel.vue';

// 色盘工具
@Component({
  components: { ColorWheelPie, ColorWheelGray, ColorWheelSub, ColorWheelRelation },
})
export default class ToolChartColor extends Vue {
  public pieColorItems: IColorDetail[] = [];
  public grayColorItems: IColorDetail[] = [];
  public pieSelected: IColorDetail | null = null;       // 色盘上选中的数据
  public relationSelected: IColorDetail | null = null;  // 关系表上选中的数据

  public onDataReady(params: IColorReadyData) {
    this.pieColorItems = params.pieColors;
    this.grayColorItems = params.grayColors;
  }
}
